import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ButtonDirective } from 'primeng/button'
import { Router } from '@angular/router'
import { PermissionService } from '@core/auth/services/permission.service'
import { Tooltip } from 'primeng/tooltip'

@Component({
  selector: 'albert-content-unit-cta-button',
  imports: [
    ButtonDirective,
    Tooltip
  ],
  templateUrl: './content-unit-cta-btn.component.html',
  styleUrl: './content-unit-cta-btn.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentUnitCtaButtonComponent {
  protected readonly router = inject(Router)
  protected readonly permissionService = inject(PermissionService)

}
